// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131241/js/" + chunkId + "." + {"44":"c02f2ccb","225":"67424651","481":"b0c2bf8f","486":"ac032636","770":"19be7d3d"}[chunkId] + ".0.5292711015884595.chunk.js";
};